/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1FeedbackFeedbackidClassStudents200,
  GetApiV1FeedbackFeedbackidClassStudents401,
  GetApiV1FeedbackFeedbackidClassStudents404,
  GetApiV1FeedbackFeedbackidClassStudents500,
  GetApiV1FeedbackFeedbackidClassStudentsPathParams,
  GetApiV1FeedbackFeedbackidClassStudentsQueryParams,
  GetApiV1FeedbackFeedbackidClassStudentsQueryResponse,
} from "../../types/feedbackTurmasController/GetApiV1FeedbackFeedbackidClassStudents.ts";
import { feedbackClassStudentViewModelPaginatedResponseSchema } from "../feedbackClassStudentViewModelPaginatedResponseSchema.ts";

export const getApiV1FeedbackFeedbackidClassStudentsPathParamsSchema = z.object(
  {
    feedbackId: z.coerce.number().int(),
  },
) as unknown as ToZod<GetApiV1FeedbackFeedbackidClassStudentsPathParams>;

export const getApiV1FeedbackFeedbackidClassStudentsQueryParamsSchema =
  z.object({
    page: z.coerce.number().int().default(1),
    pageSize: z.coerce.number().int().default(20),
  }) as unknown as ToZod<GetApiV1FeedbackFeedbackidClassStudentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1FeedbackFeedbackidClassStudents200Schema = z.lazy(
  () => feedbackClassStudentViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1FeedbackFeedbackidClassStudents200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1FeedbackFeedbackidClassStudents401Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidClassStudents401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1FeedbackFeedbackidClassStudents404Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidClassStudents404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1FeedbackFeedbackidClassStudents500Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidClassStudents500>;

export const getApiV1FeedbackFeedbackidClassStudentsQueryResponseSchema =
  z.lazy(
    () => getApiV1FeedbackFeedbackidClassStudents200Schema,
  ) as unknown as ToZod<GetApiV1FeedbackFeedbackidClassStudentsQueryResponse>;
